import { render, staticRenderFns } from "./GeneralInfoTab.vue?vue&type=template&id=699a1297"
import script from "./GeneralInfoTab.vue?vue&type=script&lang=js"
export * from "./GeneralInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports